import { PayloadAction, createSlice } from "@reduxjs/toolkit";

export enum UIFontSize {
    SMALL = "small",
    MEDIUM = "medium",
    LARGE = "large"
}

const initialState: {
    isDarkMode?: boolean;
    containerOutline?: boolean;
    customCanvasBG?: string;
    UIFontSize?: UIFontSize;
} = {
    isDarkMode: false,
    containerOutline: false,
    customCanvasBG: undefined,
    UIFontSize: UIFontSize.SMALL,
};

export const systemUISlice = createSlice({
    name: "systemUI",
    initialState,
    reducers: {
        setCustomCanvasBgColor: (state, action) => {
            state.customCanvasBG = action.payload;
        },
        setDarkMode: (state, action) => {
            state.isDarkMode = action.payload;
        },
        setContainerOutline: (state, action: PayloadAction<boolean>) => {
            state.containerOutline = action.payload;
        },
        setUIFontSize: (state, action) => {
            state.UIFontSize = action.payload;
        },
    
    }
});

export const { setCustomCanvasBgColor, setDarkMode, setContainerOutline, setUIFontSize } = systemUISlice.actions;
export default systemUISlice.reducer;
